<template>
  <div class="dashboard-pages">
    <v-card class="pa-3">
      <v-layout row>
        <v-layout row justify-start align-end>
          <v-flex shrink>
            <v-tooltip :left="!$vuetify.rtl" :right="$vuetify.rtl">
              <template v-slot:activator="{ on }">
                <v-btn
                    style="margin: 5px 0px; height: 30px; width: 30px"
                    flat
                    fab
                    v-on="on"
                    color="primary"
                    @click="openViewDialog('print')"
                >
                  <v-icon>print</v-icon>
                </v-btn>
              </template>
              <span>{{ $t(`Print Table`) }}</span>
            </v-tooltip>
            <v-tooltip :left="!$vuetify.rtl" :right="$vuetify.rtl">
              <template v-slot:activator="{ on }">
                <v-btn
                    style="margin: 5px 20px 5px 10px; height: 30px; width: 30px"
                    fab
                    flat
                    v-on="on"
                    color="primary"
                    @click="openViewDialog('export')"
                >
                  <v-icon>fa-file-excel</v-icon>
                </v-btn>
              </template>
              <span>{{ $t(`Export Table`) }}</span>
            </v-tooltip>
          </v-flex>
        </v-layout>

        <v-layout row justify-end>
          <v-flex xs2 pa-2>
            <v-autocomplete
                v-model="advancedSearch.select_date"
                :items="dateFilter"
                :label="`${$t('Select Date')}`"
                auto-select-first
                hide-details
                :error="errors.has('Select Date')"
                data-vv-name="Select Date"
                :menu-props="{ transition: 'slide-y-transition' }"
            />
          </v-flex>

          <v-flex xs2 pa-2 v-if="advancedSearch.select_date === 'DATE_PERIOD'">
            <v-menu v-model="startDateMenu" full-width max-width="290" :close-on-content-click="false">
              <v-text-field
                  slot="activator"
                  :value="advancedSearch.start_date"
                  :label="$t('Start Date')"
                  prepend-inner-icon="event"
                  readonly
                  hide-details
                  data-vv-name="start_date"
                  background-color="white"
                  autocomplete="off"
                  :error="errors.has('start_date')"
                  v-validate="'date_format:yyyy-MM-dd'"
              />
              <v-date-picker @change="startDateMenu = false" v-model="advancedSearch.start_date" />
            </v-menu>
          </v-flex>

          <v-flex xs2 pa-2 v-if="advancedSearch.select_date === 'DATE_PERIOD'">
            <v-menu v-model="endDateMenu" full-width max-width="290" :close-on-content-click="false">
              <v-text-field
                  slot="activator"
                  :value="advancedSearch.end_date"
                  :label="$t('End Date')"
                  prepend-inner-icon="event"
                  readonly
                  hide-details
                  data-vv-name="end_date"
                  background-color="white"
                  autocomplete="off"
                  :error="errors.has('end_date')"
                  v-validate="'date_format:yyyy-MM-dd'"
              />
              <v-date-picker @change="endDateMenu = false" v-model="advancedSearch.end_date" />
            </v-menu>
          </v-flex>

          <v-flex xs2 pa-3 shrink>
            <v-btn type="submit" @click="updateDataResult()" color="success">
              <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">filter_list</v-icon>
              {{ $t('Filter') }}
            </v-btn>
          </v-flex>
        </v-layout>

      </v-layout>
    </v-card>

    <v-card class="px-4 pb-4 pt-4">
      <v-progress-linear height="3" v-if="loading" :indeterminate="true" />
      <v-layout v-if="showData" row wrap class="income-statement-border">
        <v-flex xs12 pa-2 class="statement-titles">
          <v-layout  pa-2 row wrap style="font-weight: bold">
            <v-flex xs6>{{ $t('Expenses Type') }}</v-flex>
            <v-flex xs6>{{ $t('Amount') }}</v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout pa-2 row wrap v-for="(r, index) in responseData.data" :key="index" class="bottom-border">
            <v-flex xs6>{{ $t(r.expense_name) }}</v-flex>
            <v-flex xs6>{{ r.amount | currency }}</v-flex>
          </v-layout>
          <v-layout pa-2 row wrap style="font-weight: bold; color: #070b35; background: #e0ecfd">
            <v-flex xs6>{{ $t('Total') }}</v-flex>
            <v-flex xs6>{{ responseData.footer.total | currency }}</v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>

    <view-expenses-type
      :viewDialog="dialogs.viewDialog"
      @hidemodal="dialogs.viewDialog = false"
      :responseData="responseData"
      :clickedButton="clickedButton"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import Axios from 'axios'

export default {
  components: {
    viewExpensesType: () => import('./viewExpensesType.vue')
  },

  data() {
    return {
      advancedSearch: {},
      dialogs: {
        viewDialog: false
      },
      clickedButton: '',
      showData: false,
      dateMenu: false,
      loading: false,
      today: this.$moment()
        .format()
        .substr(0, 10),
      date: this.$moment()
        .format()
        .substr(0, 10),
      outlet_id: 0,
      responseData: {}
    }
  },

  computed: {
    ...mapGetters({
      outletsList: 'outlets/getFullReportOutletsList',
      dateFilter: 'expenses/getDateFilter',
      settings: 'configurations/getSystemSettings'
    })
  },

  mounted() {
    this.showData = false

    this.fetchOutletList()
    this.updateDataResult()

    this.setAppBarTitle({
      title: this.$t('Expenses Types Report'),
      icon: 'fa-chart-line'
    })
  },

  methods: {
    ...mapActions({
      resetAllErrors: 'errors/resetAllErrors',
      setErrorsList: 'errors/setErrorsList',
      fetchOutletList: 'outlets/setFullOutletsList'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    openViewDialog(clickedButton) {
      this.clickedButton = clickedButton
      this.dialogs.viewDialog = true
    },

    updateDataResult() {
      this.loading = true
      Axios.get('expense_type_report', {
        params: {
          ...this.advancedSearch
          // date: this.date
          // outlet_id: this.outlet_id
        }
      }).then(response => {
        this.responseData = {}
        this.responseData = response.data.data
        this.showData = true
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.income-statement-border {
  border: 1px solid gray;
}
.statement-titles {
  border-bottom: 1px solid gray;
  background-color: lightgray;
  font-size: 16px;
  font-weight: bold;
}
.bottom-border {
  border-bottom: 1px solid gray;
}
.top-border {
  background-color: lightgray;
  border-top: 1px solid gray;
  font-weight: bold;
}
</style>
